import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LifecycleHelper, ObservableCachingHelper } from '@coin/shared/core/util-helpers';
import { Employee, EmployeeWithCompensation, PaginatedResult } from '@coin/shared/core/util-models';

import { LoadingService } from '@coin/shared/core/data-access';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends LifecycleHelper {
  private httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);

  private cachingHelper = new ObservableCachingHelper<Employee>();

  constructor() {
    super();
    this.addToLifecycle(this.cachingHelper);
  }

  getLineManagerDirectsForEmployee(id: string): Observable<Employee[]> {
    return this.httpClient
      .get<
        PaginatedResult<Employee>
      >(`${environment.api.baseUrl}/admin/api/v3/master/employees/line-managers/directs?page=1&size=1000&id=${id}`)
      .pipe(
        map(data => data.content),
        catchError((res: HttpErrorResponse) => {
          return throwError(`Error occured. ${res?.error?.reason || 'Unknown'} `);
        })
      );
  }

  getInCompanyManagerDirectsForEmployee(id: string): Observable<Employee[]> {
    return this.httpClient
      .get<
        PaginatedResult<Employee>
      >(`${environment.api.baseUrl}/admin/api/v3/master/employees/in-company-managers/directs?page=1&size=1000&id=${id}`)
      .pipe(
        map(data => data.content),
        catchError((res: HttpErrorResponse) => {
          return throwError(`Error occured. ${res?.error?.reason || 'Unknown'} `);
        })
      );
  }

  getEmployeeDetails(id: string): Observable<Employee> {
    return this.cachingHelper.cacheSetOnMiss$(
      this.httpClient.get<Employee>(`${environment.api.baseUrl}/admin/api/v3/master/employees/${id}`).pipe(
        catchError((res: HttpErrorResponse) => {
          return throwError(`Error occured. ${res?.error?.reason || 'Unknown'} `);
        })
      ),
      [id]
    );
  }

  getEmployeeDetailsWithCompensation(id: string): Observable<EmployeeWithCompensation> {
    return this.httpClient
      .get<EmployeeWithCompensation>(`${environment.api.baseUrl}/admin/api/v3/master/employees/${id}/compensation`)
      .pipe(
        catchError((res: HttpErrorResponse) => {
          return throwError(`Error occured. ${res?.error?.reason || 'Unknown'} `);
        })
      );
  }
}
